import React from 'react';
import { ConfigStore } from '../../stores/ConfigStore';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { NumericPagination } from '../NumericPagination/NumericPagination';
import { Templates } from '../Templates/Templates';
import { SubHeader } from '../SubHeader/SubHeader';
import { CbdBanner } from '../CbdBanner/CbdBanner';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { NetworkErrorModal } from '../NetworkErrorModal/NetworkErrorModal';
import { templatesPageDataHooks } from './TemplatesPage.dataHooks';
import s from './TemplatesPage.scss';

interface TemplatesPageProps {
  configStore: ConfigStore;
  templatesStore: TemplatesStore;
  dataHook?: string;
}

const TemplatesPageCmp = ({ templatesStore, dataHook, configStore }: TemplatesPageProps) => {
  const isCBDCategory = templatesStore.loadedFetchParams?.subCategorySlug === 'cbd';

  return (
    <div className={s.templatesPage} data-hook={dataHook}>
      <SubHeader dataHook={templatesPageDataHooks.subHeader()} />
      <div className={s.templates}>
        {isCBDCategory && (
          <CbdBanner geoData={configStore.config.geoData} dataHook={templatesPageDataHooks.cbdBanner()} />
        )}

        <Templates dataHook={templatesPageDataHooks.templates()} />
      </div>

      <NumericPagination dataHook={templatesPageDataHooks.numericPagination()} />
      <NetworkErrorModal dataHook={templatesPageDataHooks.networkErrorModal()} />
    </div>
  );
};

export const TemplatesPage = injectStoresV2('templatesStore', 'configStore')(TemplatesPageCmp);
